module.exports = __webpack_public_path__ + "img/education_black_icon.5126d02e.svg";